import { RESP } from '@/_metronic/helpers/network/network-consts'
import { FC, useEffect, useState } from 'react'
import SVG from 'react-inlinesvg'
import { useParams } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Outlet } from '../outlet/core/_models'
import { getOutletById } from '../outlet/core/_requests'
import SurveyCustomerForm from './components/SurveyCustomerForm'
import { FormStateProvider, useBookingFormState } from './core/FormStateProvider'
import { ModalProvider, useSelectTreatmentModal } from './core/_ModalProvider'
import { createOrder } from './core/_requests'

const SurveyCustomerPage: FC = () => {
  const {id} = useParams()
  const [outlet, setOutlet] = useState<Outlet | undefined>(undefined)
  const {showSuccessModal} = useSelectTreatmentModal()
  const {setIsLoading} = useBookingFormState()

  const getOutletData = async () => {
    try {
      const res = await getOutletById(id)
      if (res?.response?.code === RESP.SUCCESS) {
        setOutlet(res?.response?.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (id) getOutletData()
  }, [id])

  const handleCreateOrder = async (body: any) => {
    try {
      const res = await createOrder(body)
      if (res?.response?.code === RESP.SUCCESS) {
        showSuccessModal()
        return Promise.resolve()
      }
      return Promise.reject(new Error('Failed to create order'))
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className='container z-10'>
        <div className='row justify-content-center my-5 gap-5'>
          {/* logos */}
          <div className='col-12 col-md-8 col-lg-6'>
            <div className='row'>
              <div className='col'>
                <img
                  src={toAbsoluteUrl('/media/logos/logo-all-brand.png')}
                  className='img-fluid'
                />
              </div>
            </div>
          </div>

          <div className='col-12 col-md-8 col-lg-6'>
            <div className='card py-4 px-5 shadow-wit-2 bg-illustration-order'>
              <div className='text-center'>
                <h1 className='fw-bolder mt-4'>Digital Intake & Survey Form</h1>
                <p className='text-gray-600'>
                  <SVG src={toAbsoluteUrl('/media/svg/orders/location_tick.svg')} /> Anda berada di{' '}
                  <b className='text-gray-800'>Outlet {outlet?.name}</b>
                </p>
              </div>
              {Boolean(id) && (
                <SurveyCustomerForm outlet_id={id || ''} handleSubmit={handleCreateOrder} />
              )}
              <img
                src={toAbsoluteUrl('/media/illustrations/Ilustration_order.png')}
                className='d-none d-md-block w-200px img-fluid position-absolute backdrop-order bottom-0 z-9'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const SurveyCustomerWrapper: FC = () => {
  return (
    <>
      <FormStateProvider>
        <ModalProvider>
          <SurveyCustomerPage />
        </ModalProvider>
      </FormStateProvider>
    </>
  )
}

export default SurveyCustomerWrapper
